var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cartEmptyInfo"},[_c('span',{staticClass:"cartEmptyInfo__icon"}),_vm._v("\n  Twój koszyk jest pusty\n")])
}]

export { render, staticRenderFns }